/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_Q2Inputs */

const en_to_xml_faq_q2 = /** @type {(inputs: To_Xml_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are arrays converted to XML?`)
};

const ko_to_xml_faq_q2 = /** @type {(inputs: To_Xml_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열은 XML로 어떻게 변환되나요?`)
};

const ja_to_xml_faq_q2 = /** @type {(inputs: To_Xml_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列はXMLにどう変換されますか？`)
};

/**
* | output |
* | --- |
* | "How are arrays converted to XML?" |
*
* @param {To_Xml_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_q2 = /** @type {((inputs?: To_Xml_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_q2(inputs)
	if (locale === "ko") return ko_to_xml_faq_q2(inputs)
	return ja_to_xml_faq_q2(inputs)
});